import React, { useContext } from 'react'
import { handleNotionOrExternalLink } from '../../lib/utils'
import { AccountContext } from '../../providers/accountProvider'
import CrossIcon from '../Images/CrossIcon'
import FreshChatIcon from '../Images/FreshChatIcon'
import QuestionMark from '../Images/QuestionMark'
import { FaqIconContainer, HelperIconContainer, IconContainer } from './styles'

export default function ChatBotContainer({
  isHelpButtonVisible,
  handleFaqIcon,
  toggleHelperIcon,
}) {
  const { user, isUgcUser, isHindiUgcUser } = useContext(AccountContext)
  return (
    <>
      {isHelpButtonVisible && (isUgcUser || isHindiUgcUser) ? (
        <FaqIconContainer bottom="230px">
          <div
            style={{ cursor: 'pointer' }}
            onClick={() =>
              handleNotionOrExternalLink(
                isHindiUgcUser
                  ? 'https://pocketnovel.notion.site/pocketnovel/Functional-Guide-17b81968654c4805ae2ff23b0e21be45'
                  : 'https://pocketnovel.notion.site/35838ce4579843f196a99e92ed02c2e1?v=f4fe620088cd4b8cae9e2edfa630753c&pvs=4'
              )
            }
          >
            Guide 📒
          </div>
        </FaqIconContainer>
      ) : null}
      {isHelpButtonVisible ? (
        <FaqIconContainer
          bottom="165px"
          onClick={() => {
            handleFaqIcon()
          }}
        >
          <div>FAQ's</div>
          <IconContainer>
            <QuestionMark height="7px" width="15px" fillColor="#040406" />
          </IconContainer>
        </FaqIconContainer>
      ) : null}
      {isHelpButtonVisible ? (
        user?.location === 'IN' ? (
          <FaqIconContainer
            bottom="100px"
            id="click_close_btn"
            onClick={() => {
              window?.fcWidget?.show()
              window?.fcWidget?.open()
            }}
          >
            <div>Chat</div>
            <FreshChatIcon />
          </FaqIconContainer>
        ) : (
          <FaqIconContainer bottom="100px" id="click_close_btn">
            <a href="mailto:writersupport@pocketfm.com" target="_blank">
              <div>Email Us</div>
            </a>
          </FaqIconContainer>
        )
      ) : null}
      <HelperIconContainer
        onClick={() => {
          toggleHelperIcon()
        }}
      >
        {isHelpButtonVisible ? <CrossIcon fill="#FFF" /> : <QuestionMark />}
      </HelperIconContainer>
    </>
  )
}
